const ITEMS = ["24/7 Operations Hub", "Military Grade Training", "Quick Response Team (QRT)", "Customised Solutions", "Your Safety Our Priority"];

const Row = ({ hidden }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden}>
    {ITEMS.map((t) => (
      <span key={t} className="flex items-center font-display italic font-extrabold uppercase text-3xl sm:text-5xl text-white whitespace-nowrap">
        <span className="px-8 sm:px-12">{t}</span>
        <span className="w-10 h-[4px] bg-[var(--red)] -skew-x-[40deg]" />
      </span>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <section data-testid="editorial-marquee" className="marquee-wrap relative bg-[var(--navy)] py-6 sm:py-8 overflow-hidden">
      <div className="marquee-track flex w-max">
        <Row />
        <Row hidden />
      </div>
    </section>
  );
}
